import veeMarker from "@/assets/images/icons/veeMarker.webp";
import ballon_ride from "@/assets/images/subcategories/adventure/air/ballon_ride.svg";
import hand_gliding from "@/assets/images/subcategories/adventure/air/hand_gliding.svg";
import light_flight from "@/assets/images/subcategories/adventure/air/light_flight.svg";
import parachuting from "@/assets/images/subcategories/adventure/air/parachuting.svg";
import paragliding from "@/assets/images/subcategories/adventure/air/paragliding.svg";
import puenting from "@/assets/images/subcategories/adventure/air/puenting.svg";
import caves from "@/assets/images/subcategories/adventure/aquatic/caves.svg";
import fishing from "@/assets/images/subcategories/adventure/aquatic/fishing.svg";
import flyboard from "@/assets/images/subcategories/adventure/aquatic/flyboard.svg";
import jet_skiing from "@/assets/images/subcategories/adventure/aquatic/jet_skiing.svg";
import kayak from "@/assets/images/subcategories/adventure/aquatic/kayak.svg";
import kite_surf from "@/assets/images/subcategories/adventure/aquatic/kite_surf.svg";
import paddleboard from "@/assets/images/subcategories/adventure/aquatic/paddleboard.svg";
import rafting from "@/assets/images/subcategories/adventure/aquatic/rafting.svg";
import sailboat from "@/assets/images/subcategories/adventure/aquatic/sailboat.svg";
import scuba_diving from "@/assets/images/subcategories/adventure/aquatic/scuba_diving.svg";
import snorkel from "@/assets/images/subcategories/adventure/aquatic/snorkel.svg";
import surfing from "@/assets/images/subcategories/adventure/aquatic/surfing.svg";
import water_skiing from "@/assets/images/subcategories/adventure/aquatic/water_skiing.svg";
import windsurfing from "@/assets/images/subcategories/adventure/aquatic/windsurfing.svg";
import yacht from "@/assets/images/subcategories/adventure/aquatic/yacht.svg";
import abseiling from "@/assets/images/subcategories/adventure/ground/abseiling.svg";
import canyoning from "@/assets/images/subcategories/adventure/ground/canyoning.svg";
import climbing from "@/assets/images/subcategories/adventure/ground/climbing.svg";
import hiking from "@/assets/images/subcategories/adventure/ground/hiking.svg";
import horse_riding from "@/assets/images/subcategories/adventure/ground/horse_riding.svg";
import hunting from "@/assets/images/subcategories/adventure/ground/hunting.svg";
import mountain_bike from "@/assets/images/subcategories/adventure/ground/mountain_bike.svg";
import quad_bikes from "@/assets/images/subcategories/adventure/ground/quad_bikes.svg";
import trekking from "@/assets/images/subcategories/adventure/ground/trekking.svg";
import via_ferrata from "@/assets/images/subcategories/adventure/ground/via_ferrata.svg";
import zip_line from "@/assets/images/subcategories/adventure/ground/zip_line.svg";
import expert_wine_tasting from "@/assets/images/subcategories/cellars/expert_wine_tasting.svg";
import guided_tours_cellars from "@/assets/images/subcategories/cellars/guided_tours.svg";
import tasting_and_pairing from "@/assets/images/subcategories/cellars/tasting_and_pairing.svg";
import massage from "@/assets/images/subcategories/comfort/massage.svg";
import resort from "@/assets/images/subcategories/comfort/resort.svg";
import spa from "@/assets/images/subcategories/comfort/spa.svg";
import temazcal from "@/assets/images/subcategories/comfort/temazcal.svg";
import turkish_shower from "@/assets/images/subcategories/comfort/turkish_shower.svg";
import yoga_clinics from "@/assets/images/subcategories/comfort/yoga_clinics.svg";
import bus from "@/assets/images/subcategories/culture/bus.svg";
import cultural_festivals from "@/assets/images/subcategories/culture/cultural_festivals.svg";
import cultural_routes from "@/assets/images/subcategories/culture/cultural_routes.svg";
import escape_towns from "@/assets/images/subcategories/culture/escape_towns.svg";
import guided_tours_culture from "@/assets/images/subcategories/culture/guided_tours.svg";
import religious_tours from "@/assets/images/subcategories/culture/religious_tours.svg";
import walking_tours from "@/assets/images/subcategories/culture/walking_tours.svg";
import cooking_classes from "@/assets/images/subcategories/gastronomy/cooking_classes.svg";
import gastro_experience from "@/assets/images/subcategories/gastronomy/gastro_experience.svg";
import agrotourism from "@/assets/images/subcategories/nature/agrotourism.svg";
import ecotourism from "@/assets/images/subcategories/nature/ecotourism.svg";
import greenways from "@/assets/images/subcategories/nature/greenways.svg";
import photographic_tours from "@/assets/images/subcategories/photography/photographic_tours.svg";
import photography_courses from "@/assets/images/subcategories/photography/photography_courses.svg";
import base_ball from "@/assets/images/subcategories/sports/base_ball.svg";
import basket_ball from "@/assets/images/subcategories/sports/basket_ball.svg";
import bow from "@/assets/images/subcategories/sports/bow.svg";
import bycycle from "@/assets/images/subcategories/sports/bycycle.svg";
import foot_ball from "@/assets/images/subcategories/sports/foot_ball.svg";
import golf from "@/assets/images/subcategories/sports/golf.svg";
import hockey from "@/assets/images/subcategories/sports/hockey.svg";
import tennis from "@/assets/images/subcategories/sports/tennis.svg";
import volley_ball from "@/assets/images/subcategories/sports/volley_ball.svg";
import amusement_parks from "@/assets/images/subcategories/tickets/amusement_parks.svg";
import archeological_zones from "@/assets/images/subcategories/tickets/archeological_zones.svg";
import art_gallery from "@/assets/images/subcategories/tickets/art_gallery.svg";
import concert from "@/assets/images/subcategories/tickets/concert.svg";
import museum from "@/assets/images/subcategories/tickets/museum.svg";
import theater from "@/assets/images/subcategories/tickets/theater.svg";
import escape_room from "@/assets/images/subcategories/urban_entertainment/escape_room.svg";
import fashion from "@/assets/images/subcategories/urban_entertainment/fashion.svg";
import jumping from "@/assets/images/subcategories/urban_entertainment/jumping.svg";
import karting from "@/assets/images/subcategories/urban_entertainment/karting.svg";
import paint_ball from "@/assets/images/subcategories/urban_entertainment/paint_ball.svg";
import segway from "@/assets/images/subcategories/urban_entertainment/segway.svg";
import virtual_reality from "@/assets/images/subcategories/urban_entertainment/virtual_reality.svg";
import dog_sledges from "@/assets/images/subcategories/winter/dog_sledges.svg";
import equipment_rental from "@/assets/images/subcategories/winter/equipment_rental.svg";
import ice_climbing from "@/assets/images/subcategories/winter/ice_climbing.svg";
import nordic_skiing from "@/assets/images/subcategories/winter/nordic_skiing.svg";
import ski_school from "@/assets/images/subcategories/winter/ski_school.svg";
import skiing from "@/assets/images/subcategories/winter/skiing.svg";
import snow_shoeing from "@/assets/images/subcategories/winter/snow_shoeing.svg";
import snowmobile from "@/assets/images/subcategories/winter/snowmobile.svg";
import dancing_workshop from "@/assets/images/subcategories/workshops/dancing_workshop.svg";
import painting_workshop from "@/assets/images/subcategories/workshops/painting_workshop.svg";
import pottery_workshop from "@/assets/images/subcategories/workshops/pottery_workshop.svg";

export const getSubcategoryIconProdEnv = (
  categoryId: number,
  subCategoryId: number,
) => {
  switch (categoryId) {
    case 2:
      return getCultureIconProdEnv(subCategoryId);
    case 3:
      return getGastronomyIconProdEnv(subCategoryId);
    case 4:
      return getComfortIconProdEnv(subCategoryId);
    case 5:
      return getSportsIconProdEnv(subCategoryId);
    case 7:
      return getPhotographyIconProdEnv(subCategoryId);
    case 9:
      return getTicketsIconProdEnv(subCategoryId);
    case 10:
      return getWorkshopsIconProdEnv(subCategoryId);
    case 41:
      return getAquaticAdventureIconProdEnv(subCategoryId);
    case 43:
      return getGroundAdventureIconProdEnv(subCategoryId);
    case 42:
      return getAirAdventureIconProdEnv(subCategoryId);
    case 44:
      return getCellarsIconProdEnv(subCategoryId);
    case 47:
      return getUrbanEntertainmentIconProdEnv(subCategoryId);
    case 45:
      return getWinterIconProdEnv(subCategoryId);
    case 46:
      return getNatureIconProdEnv(subCategoryId);
    default:
      return veeMarker.src;
  }
};

export const getSubcategoryIconDevelopmentEnv = (
  categoryId: number,
  subCategoryId: number,
) => {
  switch (categoryId) {
    case 2:
      return getCultureIconDevelopmentEnv(subCategoryId);
    case 3:
      return getGastronomyIconDevelopmentEnv(subCategoryId);
    case 4:
      return getComfortIconDevelopmentEnv(subCategoryId);
    case 5:
      return getSportsIconDevelopmentEnv(subCategoryId);
    case 7:
      return getPhotographyIconDevelopmentEnv(subCategoryId);
    case 9:
      return getTicketsIconDevelopmentEnv(subCategoryId);
    case 10:
      return getWorkshopsIconDevelopmentEnv(subCategoryId);
    case 41:
      return getAquaticAdventureIconDevelopmentEnv(subCategoryId);
    case 42:
      return getGroundAdventureIconDevelopmentEnv(subCategoryId);
    case 43:
      return getAirAdventureIconDevelopmentEnv(subCategoryId);
    case 44:
      return getCellarsIconDevelopmentEnv(subCategoryId);
    case 45:
      return getUrbanEntertainmentIconDevelopmentEnv(subCategoryId);
    case 46:
      return getWinterIconDevelopmentEnv(subCategoryId);
    case 47:
      return getNatureIconDevelopmentEnv(subCategoryId);
    default:
      return veeMarker.src;
  }
};

export const getWorkshopsIconDevelopmentEnv = (id: number): string => {
  switch (id) {
    case 230:
      return pottery_workshop.src;
    case 231:
      return painting_workshop.src;
    case 232:
      return dancing_workshop.src;
    default:
      return pottery_workshop.src;
  }
};

export const getWorkshopsIconProdEnv = (id: number): string => {
  switch (id) {
    case 217:
      return pottery_workshop.src;
    case 219:
      return painting_workshop.src;
    case 218:
      return dancing_workshop.src;
    default:
      return pottery_workshop.src;
  }
};

export const getWinterIconDevelopmentEnv = (id: number): string => {
  switch (id) {
    case 240:
      return skiing.src;
    case 241:
      return ice_climbing.src;
    case 242:
      return snowmobile.src;
    case 243:
      return nordic_skiing.src;
    case 244:
      return ski_school.src;
    case 245:
      return snow_shoeing.src;
    case 246:
      return dog_sledges.src;
    case 247:
      return equipment_rental.src;
    default:
      return skiing.src;
  }
};

export const getWinterIconProdEnv = (id: number): string => {
  switch (id) {
    case 200:
      return skiing.src;
    case 199:
      return ice_climbing.src;
    case 206:
      return snowmobile.src;
    case 205:
      return nordic_skiing.src;
    case 204:
      return ski_school.src;
    case 203:
      return snow_shoeing.src;
    case 202:
      return dog_sledges.src;
    case 201:
      return equipment_rental.src;
    default:
      return skiing.src;
  }
};

export const getUrbanEntertainmentIconDevelopmentEnv = (id: number): string => {
  switch (id) {
    case 233:
      return escape_room.src;
    case 234:
      return karting.src;
    case 235:
      return paint_ball.src;
    case 236:
      return segway.src;
    case 237:
      return virtual_reality.src;
    case 238:
      return jumping.src;
    case 239:
      return fashion.src;
    default:
      return escape_room.src;
  }
};

export const getUrbanEntertainmentIconProdEnv = (id: number): string => {
  switch (id) {
    case 215:
      return escape_room.src;
    case 214:
      return karting.src;
    case 213:
      return paint_ball.src;
    case 212:
      return segway.src;
    case 211:
      return virtual_reality.src;
    case 210:
      return jumping.src;
    case 216:
      return fashion.src;
    default:
      return escape_room.src;
  }
};

export const getTicketsIconDevelopmentEnv = (id: number): string => {
  switch (id) {
    case 9:
      return amusement_parks.src;
    case 10:
      return museum.src;
    case 216:
      return concert.src;
    case 217:
      return art_gallery.src;
    case 221:
      return theater.src;
    case 222:
      return archeological_zones.src;
    default:
      return concert.src;
  }
};

export const getTicketsIconProdEnv = (id: number): string => {
  switch (id) {
    case 191:
      return concert.src;
    case 192:
      return art_gallery.src;
    case 10:
      return museum.src;
    case 9:
      return amusement_parks.src;
    case 195:
      return theater.src;
    case 190:
      return archeological_zones.src;
    default:
      return concert.src;
  }
};

export const getSportsIconDevelopmentEnv = (id: number): string => {
  switch (id) {
    case 19:
      return golf.src;
    case 20:
      return foot_ball.src;
    case 21:
      return bycycle.src;
    case 207:
      return bycycle.src;
    case 208:
      return foot_ball.src;
    case 209:
      return golf.src;
    case 210:
      return tennis.src;
    case 211:
      return bow.src;
    case 212:
      return basket_ball.src;
    case 213:
      return hockey.src;
    case 214:
      return base_ball.src;
    case 215:
      return volley_ball.src;
    default:
      return golf.src;
  }
};

export const getSportsIconProdEnv = (id: number): string => {
  switch (id) {
    case 19:
      return golf.src;
    case 20:
      return foot_ball.src;
    case 21:
      return bycycle.src;
    case 186:
      return tennis.src;
    case 187:
      return bow.src;
    case 183:
      return basket_ball.src;
    case 188:
      return hockey.src;
    case 184:
      return base_ball.src;
    case 185:
      return volley_ball.src;
    default:
      return golf.src;
  }
};

export const getPhotographyIconDevelopmentEnv = (id: number): string => {
  switch (id) {
    case 223:
      return photography_courses.src;
    case 224:
      return photographic_tours.src;
    default:
      return photography_courses.src;
  }
};

export const getPhotographyIconProdEnv = (id: number): string => {
  switch (id) {
    case 220:
      return photography_courses.src;
    case 196:
      return photographic_tours.src;
    default:
      return photography_courses.src;
  }
};

export const getNatureIconDevelopmentEnv = (id: number): string => {
  switch (id) {
    case 248:
      return agrotourism.src;
    case 249:
      return ecotourism.src;
    case 250:
      return greenways.src;
    default:
      return agrotourism.src;
  }
};

export const getNatureIconProdEnv = (id: number): string => {
  switch (id) {
    case 207:
      return agrotourism.src;
    case 209:
      return ecotourism.src;
    case 208:
      return greenways.src;
    default:
      return agrotourism.src;
  }
};

export const getGastronomyIconDevelopmentEnv = (id: number): string => {
  switch (id) {
    case 14:
      return cooking_classes.src;
    case 15:
      return gastro_experience.src;
    default:
      return cooking_classes.src;
  }
};

export const getGastronomyIconProdEnv = (id: number): string => {
  switch (id) {
    case 197:
      return cooking_classes.src;
    case 198:
      return gastro_experience.src;
    default:
      return cooking_classes.src;
  }
};

export const getCultureIconDevelopmentEnv = (id: number): string => {
  switch (id) {
    case 6:
      return guided_tours_culture.src;
    case 7:
      return walking_tours.src;
    case 11:
      return religious_tours.src;
    case 200:
      return bus.src;
    case 201:
      return escape_towns.src;
    case 202:
      return cultural_festivals.src;
    case 203:
      return guided_tours_culture.src;
    case 204:
      return religious_tours.src;
    case 205:
      return cultural_routes.src;
    default:
      return guided_tours_culture.src;
  }
};

export const getCultureIconProdEnv = (id: number): string => {
  switch (id) {
    case 8:
      return guided_tours_culture.src;
    case 7:
      return walking_tours.src;
    case 11:
      return religious_tours.src;
    case 180:
      return bus.src;
    case 181:
      return escape_towns.src;
    case 178:
      return cultural_festivals.src;
    case 221:
      return guided_tours_culture.src;
    case 179:
      return cultural_routes.src;
    default:
      return guided_tours_culture.src;
  }
};

export const getComfortIconDevelopmentEnv = (id: number): string => {
  switch (id) {
    case 16:
      return spa.src;
    case 17:
      return resort.src;
    case 18:
      return yoga_clinics.src;
    case 195:
      return turkish_shower.src;
    case 197:
      return massage.src;
    case 199:
      return temazcal.src;
    default:
      return spa.src;
  }
};

export const getComfortIconProdEnv = (id: number): string => {
  switch (id) {
    case 16:
      return spa.src;
    case 17:
      return resort.src;
    case 18:
      return yoga_clinics.src;
    case 173:
      return turkish_shower.src;
    case 174:
      return massage.src;
    case 172:
      return temazcal.src;
    default:
      return spa.src;
  }
};

export const getCellarsIconDevelopmentEnv = (id: number): string => {
  switch (id) {
    case 225:
      return expert_wine_tasting.src;
    case 226:
      return tasting_and_pairing.src;
    case 227:
      return guided_tours_cellars.src;
    default:
      return expert_wine_tasting.src;
  }
};

export const getCellarsIconProdEnv = (id: number): string => {
  switch (id) {
    case 176:
      return expert_wine_tasting.src;
    case 175:
      return tasting_and_pairing.src;
    case 6:
      return guided_tours_cellars.src;
    default:
      return expert_wine_tasting.src;
  }
};

export const getAirAdventureIconDevelopmentEnv = (id: number): string => {
  switch (id) {
    case 188:
      return hand_gliding.src;
    case 189:
      return parachuting.src;
    case 190:
      return paragliding.src;
    case 191:
      return ballon_ride.src;
    case 192:
      return puenting.src;
    case 193:
      return light_flight.src;
    default:
      return hand_gliding.src;
  }
};

export const getAirAdventureIconProdEnv = (id: number): string => {
  switch (id) {
    case 157:
      return hand_gliding.src;
    case 156:
      return parachuting.src;
    case 155:
      return paragliding.src;
    case 160:
      return ballon_ride.src;
    case 159:
      return puenting.src;
    case 158:
      return light_flight.src;
    default:
      return hand_gliding.src;
  }
};

export const getGroundAdventureIconDevelopmentEnv = (id: number): string => {
  switch (id) {
    case 177:
      return canyoning.src;
    case 178:
      return mountain_bike.src;
    case 179:
      return hunting.src;
    case 180:
      return climbing.src;
    case 181:
      return quad_bikes.src;
    case 182:
      return abseiling.src;
    case 183:
      return horse_riding.src;
    case 184:
      return hiking.src;
    case 185:
      return zip_line.src;
    case 186:
      return trekking.src;
    case 187:
      return via_ferrata.src;
    default:
      return canyoning.src;
  }
};

export const getGroundAdventureIconProdEnv = (id: number): string => {
  switch (id) {
    case 165:
      return canyoning.src;
    case 166:
      return mountain_bike.src;
    case 167:
      return hunting.src;
    case 168:
      return climbing.src;
    case 169:
      return quad_bikes.src;
    case 170:
      return abseiling.src;
    case 161:
      return horse_riding.src;
    case 163:
      return hiking.src;
    case 171:
      return zip_line.src;
    case 162:
      return trekking.src;
    case 164:
      return via_ferrata.src;
    default:
      return canyoning.src;
  }
};

export const getAquaticAdventureIconDevelopmentEnv = (id: number): string => {
  switch (id) {
    case 161:
      return scuba_diving.src;
    case 163:
      return water_skiing.src;
    case 164:
      return flyboard.src;
    case 165:
      return caves.src;
    case 166:
      return jet_skiing.src;
    case 167:
      return kayak.src;
    case 168:
      return kite_surf.src;
    case 169:
      return paddleboard.src;
    case 170:
      return fishing.src;
    case 171:
      return rafting.src;
    case 172:
      return snorkel.src;
    case 173:
      return surfing.src;
    case 174:
      return sailboat.src;
    case 175:
      return windsurfing.src;
    case 176:
      return yacht.src;
    default:
      return scuba_diving.src;
  }
};

export const getAquaticAdventureIconProdEnv = (id: number): string => {
  switch (id) {
    case 152:
      return scuba_diving.src;
    case 139:
      return water_skiing.src;
    case 153:
      return flyboard.src;
    case 140:
      return caves.src;
    case 141:
      return jet_skiing.src;
    case 142:
      return kayak.src;
    case 150:
      return kite_surf.src;
    case 149:
      return paddleboard.src;
    case 148:
      return fishing.src;
    case 147:
      return rafting.src;
    case 146:
      return snorkel.src;
    case 145:
      return surfing.src;
    case 144:
      return sailboat.src;
    case 143:
      return windsurfing.src;
    case 151:
      return yacht.src;
    default:
      return scuba_diving.src;
  }
};

export const getSubcategoryTranslateKeyProd = (
  subcategoryId: number,
): string => {
  switch (subcategoryId) {
    case 152:
      return "subcategories_names.scuba_diving";
    case 139:
      return "subcategories_names.water_skiing";
    case 153:
      return "subcategories_names.flyboard";
    case 140:
      return "subcategories_names.caves";
    case 141:
      return "subcategories_names.jet_skiing";
    case 142:
      return "subcategories_names.kayak";
    case 150:
      return "subcategories_names.kite_surf";
    case 149:
      return "subcategories_names.paddleboard";
    case 148:
      return "subcategories_names.fishing";
    case 147:
      return "subcategories_names.rafting";
    case 146:
      return "subcategories_names.snorkel";
    case 145:
      return "subcategories_names.surf";
    case 144:
      return "subcategories_names.sailboat";
    case 143:
      return "subcategories_names.windsurf";
    case 151:
      return "subcategories_names.yacht";
    case 165:
      return "subcategories_names.canyoning";
    case 166:
      return "subcategories_names.mountain_bycycle";
    case 167:
      return "subcategories_names.hunting";
    case 168:
      return "subcategories_names.climbing";
    case 169:
      return "subcategories_names.quads";
    case 170:
      return "subcategories_names.abseiling";
    case 161:
      return "subcategories_names.horse_riding";
    case 163:
      return "subcategories_names.hiking";
    case 171:
      return "subcategories_names.zip_line";
    case 162:
      return "subcategories_names.trekking";
    case 164:
      return "subcategories_names.via_ferrata";
    case 157:
      return "subcategories_names.hand_gliding";
    case 156:
      return "subcategories_names.parachuting";
    case 155:
      return "subcategories_names.paragliding";
    case 160:
      return "subcategories_names.ballon_ride";
    case 159:
      return "subcategories_names.puenting";
    case 158:
      return "subcategories_names.light_flight";
    case 176:
      return "subcategories_names.expert_wine_tasting";
    case 175:
      return "subcategories_names.tasting_and_pairing";
    case 6:
      return "subcategories_names.cellars_guided_tours";
    case 16:
      return "subcategories_names.spa";
    case 17:
      return "subcategories_names.resorts";
    case 18:
      return "subcategories_names.yoga_clinics";
    case 173:
      return "subcategories_names.turkish_shower";
    case 174:
      return "subcategories_names.massages";
    case 172:
      return "subcategories_names.temazcal";
    case 8:
      return "subcategories_names.culture_guided_tours";
    case 7:
      return "subcategories_names.walking_tours";
    case 11:
      return "subcategories_names.religious_tours";
    case 180:
      return "subcategories_names.bus";
    case 181:
      return "subcategories_names.escape_towns";
    case 178:
      return "subcategories_names.cultural_festivals";
    case 221:
      return "subcategories_names.culture_guided_tours";
    case 179:
      return "subcategories_names.cultural_routes";
    case 197:
      return "subcategories_names.cooking_classes";
    case 198:
      return "subcategories_names.gastro_experiencie";
    case 207:
      return "subcategories_names.agrotourism";
    case 209:
      return "subcategories_names.ecotourism";
    case 208:
      return "subcategories_names.green_ways";
    case 220:
      return "subcategories_names.photography_courses";
    case 196:
      return "subcategories_names.photographic_tours";
    case 19:
      return "subcategories_names.golf";
    case 20:
      return "subcategories_names.foot_ball";
    case 21:
      return "subcategories_names.bycycle";
    case 186:
      return "subcategories_names.tennis";
    case 187:
      return "subcategories_names.bow";
    case 183:
      return "subcategories_names.basket_ball";
    case 188:
      return "subcategories_names.hockey";
    case 184:
      return "subcategories_names.base_ball";
    case 185:
      return "subcategories_names.volley_ball";
    case 9:
      return "subcategories_names.amusement_parks";
    case 10:
      return "subcategories_names.museums";
    case 191:
      return "subcategories_names.espect_culo";
    case 192:
      return "subcategories_names.art_galleries";
    case 195:
      return "subcategories_names.theater";
    case 190:
      return "subcategories_names.archeological_zones";
    case 215:
      return "subcategories_names.escape_rooms";
    case 214:
      return "subcategories_names.karting";
    case 213:
      return "subcategories_names.paint_ball";
    case 212:
      return "subcategories_names.segway";
    case 211:
      return "subcategories_names.virtual_reality";
    case 210:
      return "subcategories_names.jumping";
    case 216:
      return "subcategories_names.fashion";
    case 200:
      return "subcategories_names.skiing";
    case 199:
      return "subcategories_names.ice_climbing";
    case 206:
      return "subcategories_names.snowmobile";
    case 205:
      return "subcategories_names.nordic_skiing";
    case 204:
      return "subcategories_names.ski_school";
    case 203:
      return "subcategories_names.snow_shoeing";
    case 202:
      return "subcategories_names.dog_sledges";
    case 201:
      return "subcategories_names.equipment_rental";
    case 217:
      return "subcategories_names.pottery_workshops";
    case 219:
      return "subcategories_names.painting_workshops";
    case 218:
      return "subcategories_names.dancing_workshops";
    default:
      return "subcategories_names.unknown";
  }
};

export const getSubcategoryTranslateKeyDev = (
  subcategoryId: number,
): string => {
  switch (subcategoryId) {
    case 161:
      return "subcategories_names.scuba_diving";
    case 163:
      return "subcategories_names.water_skiing";
    case 164:
      return "subcategories_names.flyboard";
    case 165:
      return "subcategories_names.caves";
    case 166:
      return "subcategories_names.jet_skiing";
    case 167:
      return "subcategories_names.kayak";
    case 168:
      return "subcategories_names.kite_surf";
    case 169:
      return "subcategories_names.paddleboard";
    case 170:
      return "subcategories_names.fishing";
    case 171:
      return "subcategories_names.rafting";
    case 172:
      return "subcategories_names.snorkel";
    case 173:
      return "subcategories_names.surf";
    case 174:
      return "subcategories_names.sailboat";
    case 175:
      return "subcategories_names.windsurf";
    case 176:
      return "subcategories_names.yacht";
    case 177:
      return "subcategories_names.canyoning";
    case 178:
      return "subcategories_names.mountain_bycycle";
    case 179:
      return "subcategories_names.hunting";
    case 180:
      return "subcategories_names.climbing";
    case 181:
      return "subcategories_names.quads";
    case 182:
      return "subcategories_names.abseiling";
    case 183:
      return "subcategories_names.horse_riding";
    case 184:
      return "subcategories_names.hiking";
    case 185:
      return "subcategories_names.zip_line";
    case 186:
      return "subcategories_names.trekking";
    case 187:
      return "subcategories_names.via_ferrata";
    case 188:
      return "subcategories_names.hand_gliding";
    case 189:
      return "subcategories_names.parachuting";
    case 190:
      return "subcategories_names.paragliding";
    case 191:
      return "subcategories_names.ballon_ride";
    case 192:
      return "subcategories_names.puenting";
    case 193:
      return "subcategories_names.light_flight";
    case 225:
      return "subcategories_names.expert_wine_tasting";
    case 226:
      return "subcategories_names.tasting_and_pairing";
    case 227:
      return "subcategories_names.cellars_guided_tours";
    case 16:
      return "subcategories_names.spa";
    case 17:
      return "subcategories_names.resorts";
    case 18:
      return "subcategories_names.yoga_clinics";
    case 195:
      return "subcategories_names.turkish_shower";
    case 197:
      return "subcategories_names.massages";
    case 199:
      return "subcategories_names.temazcal";
    case 6:
      return "subcategories_names.culture_guided_tours";
    case 7:
      return "subcategories_names.walking_tours";
    case 11:
      return "subcategories_names.religious_tours";
    case 200:
      return "subcategories_names.bus";
    case 201:
      return "subcategories_names.escape_towns";
    case 202:
      return "subcategories_names.cultural_festivals";
    case 203:
      return "subcategories_names.culture_guided_tours";
    case 204:
      return "subcategories_names.religious_tours";
    case 205:
      return "subcategories_names.cultural_routes";
    case 14:
      return "subcategories_names.cooking_classes";
    case 15:
      return "subcategories_names.gastro_experiencie";
    case 248:
      return "subcategories_names.agrotourism";
    case 249:
      return "subcategories_names.ecotourism";
    case 250:
      return "subcategories_names.green_ways";
    case 220:
      return "subcategories_names.photography_courses";
    case 224:
      return "subcategories_names.photographic_tours";
    case 19:
      return "subcategories_names.golf";
    case 20:
      return "subcategories_names.foot_ball";
    case 21:
      return "subcategories_names.bycycle";
    case 207:
      return "subcategories_names.bycycle";
    case 208:
      return "subcategories_names.foot_ball";
    case 209:
      return "subcategories_names.golf";
    case 210:
      return "subcategories_names.tennis";
    case 211:
      return "subcategories_names.bow";
    case 212:
      return "subcategories_names.basket_ball";
    case 213:
      return "subcategories_names.hockey";
    case 214:
      return "subcategories_names.base_ball";
    case 215:
      return "subcategories_names.volley_ball";
    case 9:
      return "subcategories_names.amusement_parks";
    case 10:
      return "subcategories_names.museums";
    case 216:
      return "subcategories_names.espect_culo";
    case 217:
      return "subcategories_names.art_galleries";
    case 221:
      return "subcategories_names.theater";
    case 222:
      return "subcategories_names.archeological_zones";
    case 233:
      return "subcategories_names.escape_rooms";
    case 234:
      return "subcategories_names.karting";
    case 235:
      return "subcategories_names.paint_ball";
    case 236:
      return "subcategories_names.segway";
    case 237:
      return "subcategories_names.virtual_reality";
    case 238:
      return "subcategories_names.jumping";
    case 239:
      return "subcategories_names.fashion";
    case 240:
      return "subcategories_names.skiing";
    case 241:
      return "subcategories_names.ice_climbing";
    case 242:
      return "subcategories_names.snowmobile";
    case 243:
      return "subcategories_names.nordic_skiing";
    case 244:
      return "subcategories_names.ski_school";
    case 245:
      return "subcategories_names.snow_shoeing";
    case 246:
      return "subcategories_names.dog_sledges";
    case 247:
      return "subcategories_names.equipment_rental";
    case 230:
      return "subcategories_names.pottery_workshops";
    case 231:
      return "subcategories_names.painting_workshops";
    case 232:
      return "subcategories_names.dancing_workshops";
    case 223:
      return "subcategories_names.photography_courses";
    default:
      return "subcategories_names.unknown";
  }
};
